// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__F3NH2","choiceBoxes":"toolbarselects_choiceBoxes__1RyNa","simpleField":"toolbarselects_simpleField__K0Wc8"};